export var ObligationType;
(function (ObligationType) {
    ObligationType["Chapter"] = "chapter";
    ObligationType["Rule"] = "rule";
    ObligationType["Standard"] = "standard";
})(ObligationType || (ObligationType = {}));
//# sourceMappingURL=obligation-type.js.map